import { TextLinkKind,TextLinkWidget, Tooltip, TooltipPosition } from '@tableau/widgets';
import { TabStyles, } from '@tableau/widgets';
import React from 'react';

import { siteUrlsSelector } from '~src/bootstrap/redux/selectors/SiteUrlsSelectors';
import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Formatters,Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { cssClass } from '~src/style';

const rootClass: string = 'flowSubscriptionCount';

const infoIconImgPath = imgPath('info_14px_small.svg');

const infoIcon = cssClass(rootClass, 'infoIcon', {
  height: '14px',
  marginLeft: TabStyles.Spacing.DefaultSpace,
});

const countWrapper = cssClass(rootClass, 'countWrapper', {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  height: '100%',
});

const check = cssClass(rootClass, 'check', {
  padding: `0 ${TabStyles.Spacing.DefaultSpace}px`,
});

export type FlowSubscriptionCountProps = {
  count: number;
  showCheckmark: boolean;
  flowId: string;
}

export type FlowSubscriptionCountTooltipProps = {
  count: number;
}

export const FlowSubscriptionCountTooltip = (props: FlowSubscriptionCountTooltipProps) => {
  const getTooltipContent = () => {
    return <span>{Messages.flowSubscriptionsCountTooltip({SUBSCRIPTIONS_COUNT_LOC:
      Formatters.formatCount(props.count)})}</span>;
  };

 return (
  <Tooltip
    getContent={getTooltipContent}
    position={TooltipPosition.Right}
    testId={'flow-subscription-count-tooltip'}
  >
    <img className={infoIcon} src={infoIconImgPath} alt={''}/>
  </Tooltip>
 );
};

export const FlowSubscriptionCount = (props: FlowSubscriptionCountProps) => {
  const siteUrls = siteUrlsSelector(getAppStore().getState());
  return (
    props.count !== null && props.count > 0 ?
    <div className={countWrapper}>
      {props.showCheckmark && <img className={check} src={imgPath('check_14px-small.svg')} alt={Messages.linkedTasksEnabledByDefault()} />}
      <TextLinkWidget style={{height: '18px', lineHeight: '18px'}} target={'_blank'} href={siteUrls.flowSubscriptionsUrl(props.flowId)} kind={TextLinkKind.Standard} testId='flow-subscriptions-count-link'>
        {Messages.flowSubscriptionsCount({SUBSCRIPTIONS_COUNT: props.count, SUBSCRIPTIONS_COUNT_LOC: Formatters.formatCount(props.count)})}
      </TextLinkWidget>
      <FlowSubscriptionCountTooltip
        count={props.count}
      />
    </div>
    : null
  );
};
